import React from 'react';
import s from './Icon.scss';

const Icon: any = (p: any) => (
  <svg
    id={p.id}
    className={`${s.iconDefault} ${p.className}`}
    width={p.width || p.size}
    height={p.height || p.size}
    viewBox={p.viewBox}
  >
    {p.children}
  </svg>
);

Icon.defaultProps = {
  size: '1em',
};

export default Icon;
